import { Directive, Input, ElementRef, AfterViewInit } from '@angular/core';
import { BaseValidator } from './base.directive';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';
import { ValidationTypes } from './validator-const.model';
import { TranslationService } from '../../common/services/translation.service';

const START_WITH_WHITE_SPACE_REGEX = /^(\s)+/;

@Directive({
    selector: '[cpqRequired]',
    providers: [{ provide: NG_VALIDATORS, useExisting: CpqRequiredDirective, multi: true }],
    standalone: false
})
export class CpqRequiredDirective extends BaseValidator implements Validator, AfterViewInit {

    @Input() cpqRequired?: boolean;
    constructor(private el: ElementRef, private translationService: TranslationService) {
        super();
    }

    validate(c: AbstractControl): { [key: string]: any; } {
        if (!this.isRequired) {
            return null;
        } else {
            const value = typeof (c.value) === 'number' ? c.value.toString() : c.value;            
            if(START_WITH_WHITE_SPACE_REGEX.test(value)) {
                return this.createMessage(ValidationTypes.cpqRequired, this.translationService.translate('Msg.CannotStartWithWhiteSpace'));
            } else if(!value || !value.length) {
                return this.createMessage(ValidationTypes.cpqRequired, this.translationService.translate('xsltRequired'));
            }
            return null;
        }
    }

    ngAfterViewInit() {
        const label = this.el.nativeElement.querySelector('label');
        if (label && this.isRequired) {
            label.innerHTML += ` <span style="color: #b00;">*</span>`;
        }
    }

    private get isRequired(): boolean {
        return this.cpqRequired !== false;
    }
}
